export const header = () => ({
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '32px 30px 40px',
});
